<app-simple-responsive-frame>
    <div class="ad-wrapper">
        <div class="ad-container">
            <h2>¿Qué quieres hacer con tu {{ segmentLabel?.toLowerCase() }}?</h2>

            <p class="offers-hint" *ngIf="registeredOffers.length">
                Ya registraste {{ registeredOffers.length }} oferta(s). Puedes agregar otra o
                <b>Concluir registro</b> abajo.
            </p>

            <div class="offers">
                <button type="button"
                        *ngFor="let offer of offers"
                        class="offer-card"
                        [class.selected]="isSelected(offer)"
                        [class.registered]="isRegistered(offer)"
                        (click)="selectOffer(offer)">
                    <i class="pi pi-arrow-circle-right offer-icon" aria-hidden="true"></i>
                    <span class="offer-text">
                        <span class="offer-title">
                            {{ offer.adLabel }}
                            <span *ngIf="isRegistered(offer)" class="offer-badge">
                                <i class="pi pi-check-circle" aria-hidden="true"></i> Ya la ofreces
                            </span>
                        </span>
                        <span class="offer-desc" [ngClass]="getIconClassForOffer(offer.adLabel)">
                            {{ offer.description || 'Sin descripción' }}
                        </span>
                    </span>
                </button>
            </div>

            <div class="additional-option">
                <a (click)="selectBankAuction()" class="bank-link clickable">Quiero subir un remate bancario</a>
            </div>

            <div *ngIf="showConcludeButton" class="additional-option">
                <a (click)="concludeRegistration()" class="conclude-link clickable">Concluir registro</a>
            </div>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="90"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'ad'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
